import { useMutation } from '@apollo/client';
import { FormProvider } from 'react-hook-form';
import { toast } from 'react-toastify';
import invariant from 'tiny-invariant';
import { graphql } from '~/apollo/generated/v3';
import { Panel } from '~/components/common/Panel';
import { Button } from '~/components/ui/button';
import { HookFormErrors } from '~/components/ui/forms/HookFormErrors';
import { RegionFormFields } from '~/components/upload/region/region-form-fields';
import { useZodForm } from '~/utils/forms';
import { initialRegion, regionSchema } from '~/utils/modules/region';
import { useUploadRegionUpdatePageContext } from '../$regionId';

const UPDATE_REGION = graphql(`
  mutation UpdateRegion($id: Int!, $region: RegionInput!) {
    updateRegion(id: $id, region: $region) {
      ...regionParts
    }
  }
`);

export default function UploadRegionOverviewTab() {
  const { region } = useUploadRegionUpdatePageContext();
  invariant(region, 'region is required');

  const [updateRegion, { loading, error }] = useMutation(UPDATE_REGION);

  const form = useZodForm({
    schema: regionSchema,
    values: initialRegion(region),
  });

  const handleSubmit = form.handleSubmit(async values => {
    try {
      await updateRegion({
        variables: {
          id: region.id,
          region: values,
        },
      });
      toast.success('Region updated successfully.');
    } catch (err) {
      console.log('Error updating region', err);
      toast.error('There was a problem updating the region.');
    }
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit}>
        <Panel>
          <Panel.Heading>
            <Panel.Title>Region Details</Panel.Title>
          </Panel.Heading>

          <Panel.Body className="space-y-4">
            <RegionFormFields />
            <HookFormErrors graphQLError={error} />
          </Panel.Body>

          <Panel.Footer className="text-right">
            <Button type="submit" color="primary" loading={loading}>
              Save
            </Button>
          </Panel.Footer>
        </Panel>
      </form>
    </FormProvider>
  );
}
